module.exports = __webpack_public_path__ + "static/media/zendesk_icon.8228b77c.svg";